import * as React from 'react';
import { useState } from 'react';
import { Button } from '../../../../../../shared/ui/button';
import { Checkbox } from '../../../../../components/common/checkbox';
import { Flex } from '../../../../../components/common/flex';
import { Modal } from '../../../../../components/common/modal';
import { useResize } from '../../../../../hooks/use_resize';
import { IBookCorrectionModalProps } from './book_correction_modal.d';

export const BookCorrectionModal: React.FC<IBookCorrectionModalProps> = ({
  open,
  onClose,
  correctionReasons,
  onSubmit,
}) => {
  const [selectedReasons, setSelectedReasons] = useState<number[]>([]);

  const { isMobile } = useResize();

  const handleToggle = (reasonValue: number) => {
    setSelectedReasons((prevState) => {
      const index: number = prevState.indexOf(reasonValue);
      if (index === -1) {
        return [...prevState, reasonValue];
      } else {
        const newState = [...prevState];
        newState.splice(index, 1);
        return newState;
      }
    });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      footer={
        <>
          <Button variant={'outline'} onClick={onClose}>
            Отмена
          </Button>
          <Button
            variant={'filled'}
            color={'primary'}
            onClick={() => onSubmit(selectedReasons)}
            disabled={!selectedReasons.length}
          >
            Скорректировать
          </Button>
        </>
      }
      className={'book-action-modal modal_mobile-height_auto'}
      size={isMobile ? 'xs' : 'sm'}
    >
      <div className={'typography-h2'}>Корректировка заявки</div>
      <div>Укажите причину корректировки:</div>
      <Flex vertical className={'typography-regular'}>
        {correctionReasons.map((item) => (
          <Checkbox
            label={item.text}
            value={selectedReasons.includes(item.value)}
            onChange={() => handleToggle(item.value)}
            key={item.value}
          />
        ))}
      </Flex>
    </Modal>
  );
};
